export default __webpack_public_path__ + "static/media/left8.63aabf9b.png";